import { render, staticRenderFns } from "./PhoneNumberCarrierDetails.vue?vue&type=template&id=f96ccade&scoped=true&"
import script from "./PhoneNumberCarrierDetails.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberCarrierDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96ccade",
  null
  
)

export default component.exports